import { createSafeContext } from '@shared/utils';

interface AccordionItemContext {
  value: string;
  isLoading: boolean;
}

export const [AccordionItemProvider, useAccordionItemContext] =
  createSafeContext<AccordionItemContext>('Accordion.Item');
